import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {WmHttpService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})
export class JobStatusService {
  TARGET = "Job";
  API_META = {
    getJobs:{
      'url':environment.SERVICES_BASE_PATH +  "services/jobs/project/:projectId",
      'method':'GET',
      spinnerInfo: {
        showSpinner: false
      }
    },
    cancelJob:{
      'url':"",
      'method':"POST"
    }
  }
  jobDataInProgress: any = [];
  showJobSuccess: boolean;
  showJobError: boolean;


  constructor(private wmHttpService: WmHttpService) {
    wmHttpService.registerApiMeta(this.TARGET, this.API_META)
  }

  getJobs(params: any, urlParams:any): Promise<any> {
    return (this.wmHttpService.execute({
      target:this.TARGET,
      action:'getJobs',
      data:params,
      urlParams: urlParams
    }) as Promise<any>)
  }
}
